import { STORIES } from '../model/data';

export const preloadStories = () => {
    const allImages: string[] = [];

    STORIES.forEach((story) => {
        if (story.image) allImages.push(story.image);

        story.includedStories.forEach((includedStory) => {
            allImages.push(includedStory.backgroundImage);
        });
    });

    allImages.forEach((imageUrl) => {
        const img = document.createElement('img');

        img.src = imageUrl;
        img.style.opacity = '0';
        img.style.position = 'absolute';
        img.style.width = '1px';
        img.style.height = '1px';
        img.style.pointerEvents = 'none';
        img.style.zIndex = '-1';
        document.body.appendChild(img);
    });
};
